export interface FileUploadContext {
    oid: string;
}

export abstract class FileUploadControlComponentDelegate {
    abstract setContext(context: FileUploadContext): void;
    abstract getContext(): FileUploadContext | null;
}
